// Imports => MOBX
import { observable, computed, makeObservable, action, toJS } from 'mobx';
import { getDataSource } from '../config/store.config';

let app = {};

export class PagesStore {
  constructor(store) {
    makeObservable(this);
    app.store = store;
    // Use the API instead of mock data
    this.dataSource = app.store.api.pages;
  }

  @observable
  items = [];

  @observable
  single = {};

  @observable
  loading = {
    status: false,
    message: undefined,
  };

  @computed
  get is_loading() {
    return this.loading.status;
  }

  @computed
  get all_pages() {
    return this.items ? toJS(this.items) : [];
  }

  @computed
  get get_single() {
    return this.single ? toJS(this.single) : null;
  }

  @action
  resetPage = () => {
    this.single = {};
  };

  @action
  setLoadingStatus = (status) => {
    this.loading.status = status;
  };

  @action
  setPages = (items) => {
    this.items = items;
  };

  @action
  setPage = (page) => {
    this.single = page;
  };

  @action
  fetchPage = async (path) => {
    this.loading.status = true;

    try {
      // Extract slug from path
      const slug = path === '/' ? 'home' : path.replace(/^\//, '');
      console.log(`Fetching page with slug: ${slug}`);
      const page = await this.dataSource.single(slug);
      console.log('Page fetched successfully:', page);
      this.setPage(page);
    } catch (e) {
      console.error(`Error fetching page for path ${path}:`, e);
      // Set empty page on error to avoid UI issues
      this.setPage({});
    } finally {
      this.loading.status = false;
    }
  };

  @action
  fetchPages = async () => {
    this.loading.status = true;

    try {
      console.log('Fetching pages from API:', this.dataSource);
      const pages = await this.dataSource.list();
      console.log('Pages fetched successfully:', pages);
      this.setPages(pages);
    } catch (e) {
      console.error('Error fetching pages:', e);
      // Set empty pages array on error to avoid UI issues
      this.setPages([]);
    } finally {
      this.setLoadingStatus(false);
    }
  };
}

export default PagesStore;
